import { Badge } from '@repo/components/badge';

export function EnvironmentIndicator({
  className,
  label,
  visible,
}: {
  className?: string;
  label: 'LOCAL' | 'DEV' | 'UAT' | null;
  visible: boolean;
}) {
  if (!visible || !label) {
    return null;
  }

  const title = `Environment: ${label}`;

  return (
    <Badge
      color="warning"
      className={className}
      aria-label={title}
      title={title}
    >
      {label}
    </Badge>
  );
}
